var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { EventEmitter, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
var MappingAssignedNumberComponent = /** @class */ (function () {
    function MappingAssignedNumberComponent() {
        this.changeEditMode = new EventEmitter();
        this.delete = new EventEmitter();
        this.changed = new EventEmitter();
    }
    MappingAssignedNumberComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.form.get('msisdnId').valueChanges.subscribe(function (msisdnId) { return _this.setSelectedMsisdn(msisdnId); });
    };
    MappingAssignedNumberComponent.prototype.ngOnChanges = function (changes) {
        this.setSelectedMsisdn(this.form.get('msisdnId').value);
    };
    MappingAssignedNumberComponent.prototype.setSelectedMsisdn = function (msisdnId) {
        if (this.msisdns) {
            this.selectedMsisdn = this.msisdns.find(function (el) { return el.id === msisdnId; });
        }
    };
    MappingAssignedNumberComponent.prototype.onSelectChange = function (event, selectedMsisdn) {
        this.form.patchValue(__assign({}, selectedMsisdn, { msisdnId: event.value }));
    };
    MappingAssignedNumberComponent.prototype.isAddPhoneNumber = function () {
        return this.editMode && this.form.get('callerIdLabel').value;
    };
    return MappingAssignedNumberComponent;
}());
export { MappingAssignedNumberComponent };
